module.exports = __webpack_public_path__ + "static/media/pro_live_tool.7f8400eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/live/assets/pro_live_tool.jpg
// module id = 410
// module chunks = 0